




































































import {
  defineComponent,
  reactive,
  computed,
  ref,
  onMounted,
  Ref,
  watch,
} from '@vue/composition-api';
import _ from 'lodash';
import { useRouter, useFormat } from '@ideavivat/vivat-2';
import { ToggleButton } from 'vue-js-toggle-button';

import {
  getRoles,
  getUsers,
  updateUser,
  createRole,
  deleteRole,
  deleteUser,
} from '@/api/index';
import user from '@/table/user';
import CommonFormWithRoleEditor from '@/components/User/CommonFormWithRoleEditor.vue';
import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import useAuth from '@/use/useAuth';

const List = defineComponent({
  setup() {
    const { route } = useRouter();
    const { hasPermission } = useAuth();
    const refetchQuery = ref(false);
    const tempRoleDelete = -1;
    const confirmModal = ref(null);
    const getRoleDisplayFromRoute = '';
    const resultGetRole: any[] = [];
    const roles: Ref<{ id: number; name: string }[]> = ref([]);
    async function getRoleData() {
      const result = await getRoles({});
      roles.value = result.data;
    }
    const pendingSearch = _.debounce(() => {
      refetchQuery.value = true;
    }, 250);

    onMounted(async () => {
      await getRoleData();
    });

    const formCreate = reactive({
      name: '',
      call: async () => {
        const result = await createRole({ name: formCreate.name });
        await getRoleData();
        (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'ข้อมูลเรียบร้อย' });
      },
    });
    async function deleteRoleFunction(id: number) {
      await deleteRole(id);
      await getRoleData();
    }

    // =================== DELETE FUNCTION ======================
    // Delete dialog
    const deleteUserModal = ref(null);
    // Delete Mutation variables
    const deleteUserVariable = reactive({ id: -1 });
    async function deleteUserAction(ctx: any) {
      await deleteUser(ctx.id);
      refetchQuery.value = true;
    }

    // Active Deactive Mutation
    const toggleVariables = reactive({
      id: -1,
      status: true,
    });

    async function setActiveStatus(id: any, status: boolean) {
      toggleVariables.id = id;
      toggleVariables.status = status;
      await updateUser(toggleVariables.id, { active: toggleVariables.status });
    }

    // ==== Use to search User ==== //
    // Search filter
    const search = reactive({
      text: '',
    });
    const usersListVariables = computed(() => {
      const vars: { [key: string]: any } = {
        searchName: undefined,
        role_id: route.value.params.roleId,
      };
      if (search.text) {
        vars.searchName = `%${search.text}%`;
      }
      return vars;
    });

    // ==== Use Format ==== //
    function useDateTimeFormat(date: any) {
      if (!date) return '';
      return `${useFormat
        .date(date)
        .displayShortThaiDate()} เวลา ${date.substring(11, 16)}`;
    }

    watch(() => route.value.params.roleId, (newVal, oldVal) => {
      if (newVal !== oldVal && newVal !== '') {
        refetchQuery.value = true;
      }
    });

    const pendingToActionUser = reactive({ id: -1 });
    const pendingChangeRole = ref(-1);

    return {
      pendingSearch,

      roles,
      getUsers,
      refetchQuery,
      formCreate,
      userTableOption: user,
      search,
      tempRoleDelete,
      // Delete User funtion
      deleteUserModal,
      deleteUserAction,
      // User list gql
      usersListVariables,
      setActiveStatus,
      useDateTimeFormat,
      resultGetRole,
      getRoleDisplayFromRoute,
      updateUser,
      getRoleData,
      deleteRoleFunction,
    };
  },
  components: {
    ToggleButton,
    CommonModalWithPreset,
    CommonFormWithRoleEditor,
  },
});

export default List;
